// Use $ instead of $ without replacing global $
(function ($) {

  // tabs function
  $(document).ready(function () {

    $('.tab-content-outer .tab-content .tab-pane:eq(0)').addClass('active show');

      $('body .tabs .tabs-wrap .tab-list .nav li:eq(0) a').addClass('active');


    $('.tabs .nav-pills li a').click(function (e) {
      e.preventDefault();
      var tab_id = $(this).attr('data-tab');

      $('.tabs .nav-pills li a').removeClass('active');
      $('.tab-content-outer .tab-content .tab-pane').removeClass('active show');

      $(this).addClass('active');
      $("#" + tab_id).addClass('active show');
    });

    $(document).on('click', '.tabs .tab-list .tab-panel-outer .private-toggle', function (event) {
      event.stopPropagation();
      $('.tabs .tab-list .tab-panel-outer ul').stop(true, true).slideToggle();
      $(".tabs .tab-list .tab-panel-outer .caret").toggleClass("closeup");
    });

    $('.tabs .tab-list .tab-panel-outer > ul > li > a,body .curve-down .tabs .tabs-wrap .tab-list .tab-panel-outer .responsive-tab li a ').click(function (e) {
      e.preventDefault();
      var index = $(this).index();
      var $thisText = $(this).text();
      var tab_id = $(this).attr('data-tab');

      $(this).parents('ul').find('li > a').removeClass('active');
      $(this).parents('.tabs-wrap').find('.tab-content-outer .tab-content .tab-pane').removeClass('active');

      $('.tabs .responsive-tab li a').removeClass('active');
      $(this).addClass('active');
      $('.tab-content-outer .tab-content .tab-pane').removeClass('active show');
      $("#" + tab_id).addClass('active show');
      $(this).parents('.tabs-wrap').find('.tab-content-outer .tab-content .tab-pane:eq(' + index + ')').addClass('active');


      windowWidth = $(window).width();
      $(".tabs .tab-list .tab-panel-outer .text").text($thisText);
      if (windowWidth <= 767) {
        $('.tabs .tab-list .tab-panel-outer ul').stop(true, true).slideUp();
        $(".tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");

      }
    });
    $(document).click(function (event) {
      event.stopPropagation();
      windowWidth = $(window).width();
      if (windowWidth <= 767) {
        $(".tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");
        $('.tabs .tab-list .tab-panel-outer ul').slideUp();
      }
    });

    var tabHeight = $('.tabs .tabs-wrap .tab-content-outer .tab-content').outerHeight();
    $('.tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});


    $('.tabs .tabs-wrap .tab-list ul li a').on('click', function () {
      // var index = $(this).parent().index() + 1;
      // var height = $(this).parent().height();
      // var total = index * height;

      //
      // $(this).parents('ul').find('li').each(function (index1) {
      //   // console.log(index1);
      //   var index2 = $(this).index() + 1;
      //   console.log("index2==", index2);
      //
      //   var list_height = $(this).height();
      //   console.log("list_height==", list_height);
      //
      //   var total = total + list_height;
      //
      //   if (index == index2) {
      //     return false;
      //   }
      //
      // });


      // $(this).parents().find('.nav-tabs .red-line').css({'top': total - '55' + 'px'});
      //
      // if ((index == 1)) {
      //   $(this).parents().find('.nav-tabs .red-line').css({'top': total - '40' + 'px'});
      // }
      // if ((index == 8)) {
      //   $(this).parents().find('.nav-tabs .red-line').css({'top': total - '70' + 'px'});
      // }

    });

    // Inactive the button untill checkbox click
    $('.form-check .form-check-input').change(function () {
      if ($(this).is(":checked")) {
        $('.button a').addClass('btn-red');
        $('.button a').removeClass('btn-grey');
      } else {
        $('.button a').removeClass('btn-red');
        $('.button a').addClass('btn-grey');
      }
    });

  });

  //On load function
  $(window).on("load resize", function () {
    windowWidth = jQuery(window).width();
    if (windowWidth > 767) {
      $(".tabs .tab-list .tab-panel-outer ul").removeAttr("style");
      $(".tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");
    }

    var tabHeight = $('.tabs .tabs-wrap .tab-content-outer .tab-content .tab-pane').outerHeight();
    $('.tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});

  });


})(jQuery);